// extracted by mini-css-extract-plugin
export default {"disclosure":"disclosure__Z9TcL","popupWrapper":"popupWrapper__qogKZ"};